import store from '../'

let resource = store.defineResource({
  name: "annotationFavorites",
  endpoint: "annotation-favorites",
  relations: {
    belongsTo: {
      users: {
        parent: true,
        localKey: "userId",
        localField: "user"
      }
    }
  }
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/annotation-favorites.js